import { useEffect, useState } from "react"
import { WatchMovieDiv, PlayMovieDiv, SynopsisDiv } from "../../Utils/style"
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import { MovieInfosDiv, MoviesInfosLink } from "../../Components/MovieDetails"
import styled from "styled-components"
import { colors } from "../../Utils/color"
import { slugify } from "../../Components/MoviesSlider"
import AdsterraBanner from "../../Components/AdsterraBanner"
import { AddBannerDiv } from "../Home"

const SerieDetailsDiv = styled.div`
    display: flex;
    gap: 15px;
    margin: 10px 10px;
    margin-bottom: 30px;

    @media screen and (min-width: 768px) {
        gap: 20px;
        margin: 20px 0;
    }

    > img {
        width: 18vh;
        height: 24vh;
        border-radius: 10px;
        background-color: ${colors.secondary};

        @media screen and (min-width: 768px) {
            width: 26vh;
            height: 36vh;
        }
    }
`
const SaisonsDiv = styled.div`
    > .seasonsEpisodes {
        width: 95%;
        height: 75px;
        margin: 10px auto;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: 1px solid rgba(130, 130, 130, 0.1);
        border-radius: 10px;
        @media screen and (min-width: 768px) {
            width: 90%;
        }
        @media screen and (min-width: 1024px) {
            width: 80%;
        }

        .seasonLine {
            background-color: rgba(130, 130, 130, 0.1);
            width: 1px;
            height: 75px;
            margin: 0;
        }
    }
    h2 {
        width: 100%;
        display: flex;
        justify-content: center;
        font-size: 1.5em;
        margin: 0;
        margin-bottom: 4px;
        @media screen and (min-width: 768px) {
            font-size: 1.6em;
        }
    }

    > .nbSeasons {
        display: flex;
        justify-content: center;
        gap: 15px;
        flex-wrap: wrap;
        > button {
            font-size: 0.9em;
            font-weight: 600;
            color: ${colors.textColor};
            background: none;
            padding: 12px 23px 11px 23px;
            border: 0.5px solid rgba(250, 250, 250, 0.8);
            border-radius: 30px;
            cursor: pointer;
            &:hover {
                background-color: rgba(130, 130, 130, 0.2);
            }
        }
    }
`

function SerieInfos() {
    const [searchParams] = useSearchParams()

    const { serieName } = useParams()
    const serieID = searchParams.get("serie_id")

    const [serieInfos, setSerieInfos] = useState([])
    const [date, setDate] = useState()
    const [dateDerniers, setDateDerniers] = useState()
    const [acteurs, setActeurs] = useState([])
    const [real, setReal] = useState([])
    const [genres, setGenres] = useState([])
    const [pays, setPays] = useState([])
    const [nbSaisons, setNBSaisons] = useState([])

    const fetchSerie = async (id) => {
        try {
            const API_BASE =
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:8787"
                    : window.location.origin

            const response = await fetch(`${API_BASE}/api/series/serie/${id}`)
            const json = await response.json()

            setSerieInfos(json.serie)
            setDate(json.serie.date_sortie.slice(0, 4))
            setDateDerniers(json.serie.date_derniers_episode.slice(0, 4))
            setActeurs(json.serie.acteurs.split(","))
            setReal(json.serie.realisateurs.split(","))
            setGenres(json.genres)
            setPays(json.pays)

            const array = []
            for (let i = 1; i <= json.serie.nb_saisons; i++) {
                array.push(i)
            }
            setNBSaisons(array)

            document.titre = `${
                json.serie.titre ?? "Serie"
            } | en streaming complet`
        } catch (error) {
            console.log("Fetch error: ", error)
        }
    }

    useEffect(() => {
        fetchSerie(serieID)
    }, [serieID])

    const navigate = useNavigate()
    const showSeasonHandleClick = (seasonNumber) => {
        navigate(
            `/serie/watch/${serieName}?serie_id=${serieID}&saison=${seasonNumber}`,
        )
    }

    const isMobile = window.innerWidth < 768

    return (
        <WatchMovieDiv>
            <h1>
                <span></span>
                {serieInfos.titre}
            </h1>

            <PlayMovieDiv>
                <img src={serieInfos.cover} alt="Movie cover" />
            </PlayMovieDiv>

            <AddBannerDiv style={{ marginTop: "5px" }}>
                <p>
                    Cliquer sur les pub est le meilleur moyen de nous soutenir
                </p>
                {isMobile ? (
                    <AdsterraBanner
                        keyId="36095d1eafe994c25e794db19ac32ddd"
                        width={320}
                        height={50}
                    />
                ) : (
                    <AdsterraBanner
                        keyId="dcfa5d9b41f84b62a0d227806e4b1618"
                        width={728}
                        height={90}
                    />
                )}
            </AddBannerDiv>

            <SerieDetailsDiv>
                <img src={serieInfos.cover} alt="Movie Cover" />
                <MovieInfosDiv>
                    <p>
                        <span>Titre Original</span>
                        <MoviesInfosLink
                            style={{
                                cursor: "text",
                                pointerEvents: "none",
                                textDecoration: "none",
                            }}
                        >
                            {serieInfos.titre_original}
                        </MoviesInfosLink>
                    </p>
                    <p>
                        <span>Dates</span>
                        <MoviesInfosLink
                            style={{
                                cursor: "text",
                                pointerEvents: "none",
                                textDecoration: "none",
                            }}
                        >
                            {date}
                            <span
                                style={{
                                    display:
                                        date !== dateDerniers
                                            ? "initial"
                                            : "none",
                                }}
                            >
                                {" "}
                                - {dateDerniers}
                            </span>
                        </MoviesInfosLink>
                    </p>
                    <p>
                        <span>Durée</span>
                        <MoviesInfosLink
                            style={{
                                cursor: "text",
                                pointerEvents: "none",
                                textDecoration: "none",
                            }}
                        >
                            {serieInfos.duree}
                        </MoviesInfosLink>
                    </p>
                    <p>
                        <span>Genres</span>
                        {genres.map((genre) => (
                            <MoviesInfosLink
                                to={"/series?page=1&genre=" + genre}
                            >
                                {genre}
                            </MoviesInfosLink>
                        ))}
                    </p>
                    <p>
                        <span>Réalisateurs</span>
                        {real.map((real) => (
                            <MoviesInfosLink
                                to={"/realisateurs/" + slugify(real)}
                                state={{ name: real }}
                            >
                                {real}
                            </MoviesInfosLink>
                        ))}
                    </p>
                    <p>
                        <span>Acteurs</span>
                        {acteurs.map((actors) => (
                            <MoviesInfosLink
                                to={"/acteurs/" + slugify(actors)}
                                state={{ name: actors }}
                            >
                                {actors}
                            </MoviesInfosLink>
                        ))}
                    </p>
                    <p
                        style={{
                            display: pays ? "none" : "flex",
                        }}
                    >
                        <span>Pays d'origine</span>
                        {pays.map((pays) => (
                            <MoviesInfosLink to={"/series?page=1&pays=" + pays}>
                                {pays}
                            </MoviesInfosLink>
                        ))}
                    </p>
                    <p>
                        <span>Note Série</span>
                        <MoviesInfosLink
                            style={{
                                cursor: "text",
                                pointerEvents: "none",
                                textDecoration: "none",
                            }}
                        >
                            {serieInfos.note_serie}
                        </MoviesInfosLink>
                    </p>
                </MovieInfosDiv>
            </SerieDetailsDiv>

            <SynopsisDiv style={{ marginTop: "11px" }}>
                <h2>
                    <span></span>Synopsis & infos
                </h2>
                <p>{serieInfos.synopsis_serie}</p>

                <SaisonsDiv>
                    <div className="seasonsEpisodes">
                        <h2>{serieInfos.nb_saisons} Saisons</h2>
                        <p className="seasonLine"></p>
                        <h2>{serieInfos.total_episodes} Episodes</h2>
                    </div>
                    <div className="nbSeasons">
                        {nbSaisons.map((nb) => (
                            <button onClick={() => showSeasonHandleClick(nb)}>
                                Voir la Saison {nb}
                            </button>
                        ))}
                    </div>
                </SaisonsDiv>
            </SynopsisDiv>
        </WatchMovieDiv>
    )
}

export default SerieInfos
